import { render, staticRenderFns } from "./worksbiz.vue?vue&type=template&id=78d7cda0&"
import script from "./worksbiz.vue?vue&type=script&lang=js&"
export * from "./worksbiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports